import { useEffect } from 'react';

import { getTelegramWebApp, telegramReady } from '@app/shared/utils/common';

export const useTelegramExpandOnMount = () => {
  useEffect(() => {
    telegramReady();
    const tg = getTelegramWebApp();
    tg?.expand();
  }, []);
};
